var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwpmDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#e5e5e5",
    height: 363,
    id: "svg_5",
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 5,
    width: 285.99999,
    x: 60.50001,
    y: 17.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e5e5e5",
    height: 274,
    id: "svg_2",
    stroke: "#cccccc",
    strokeWidth: 2,
    width: 296.99998,
    x: 55.50001,
    y: 60.50001
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e5e5e5",
    height: 254,
    id: "svg_3",
    stroke: "#b2b2b2",
    width: 298.99999,
    x: 54.50001,
    y: 69.50001
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#bac9d6",
    height: 238,
    id: "svg_6",
    stroke: "#999999",
    strokeWidth: 2,
    width: 287.49999,
    x: 60.00001,
    y: 78.49999
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#333333",
    height: 28,
    id: "svg_19",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    width: 31,
    x: 124.5,
    y: 258.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#333333",
    height: 28,
    id: "svg_23",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    width: 31,
    x: 171.5,
    y: 258.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#333333",
    height: 28,
    id: "svg_24",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    width: 31,
    x: 261,
    y: 258.5
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 10,
    fontWeight: "normal",
    id: "svg_11",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 140,
    xmlSpace: "preserve",
    y: 277
  }, "MODE"), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "normal",
    id: "svg_27",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 186.5,
    xmlSpace: "preserve",
    y: 277.5
  }, "\u25B2"), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: "normal",
    id: "svg_28",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 277.5,
    xmlSpace: "preserve",
    y: 276.5
  }, "SET"), /*#__PURE__*/React.createElement("rect", {
    fill: "#333333",
    height: 103,
    id: "svg_9",
    rx: 10,
    ry: 10,
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 2,
    width: 280,
    x: 64,
    y: 139.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_10",
    stroke: "#7f7f7f",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    x1: 115,
    x2: 299,
    y1: 202.5,
    y2: 199.5
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: "normal",
    id: "svg_25",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 0,
    textAnchor: "middle",
    x: 125,
    xmlSpace: "preserve",
    y: 115
  }, "POWER"), /*#__PURE__*/React.createElement("rect", {
    fill: "#bdf981",
    height: 9,
    id: "svg_22",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    width: 15,
    x: 87.5,
    y: 106.5
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: "normal",
    id: "svg_13",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 0,
    textAnchor: "middle",
    x: 116,
    xmlSpace: "preserve",
    y: 134
  }, "ERR"), /*#__PURE__*/React.createElement("rect", {
    fill: "#333333",
    height: 9,
    id: "svg_14",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    width: 15,
    x: 87.5,
    y: 125.5
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: "normal",
    id: "svg_16",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 0,
    textAnchor: "middle",
    x: 315,
    xmlSpace: "preserve",
    y: 115
  }, "RD"), /*#__PURE__*/React.createElement("rect", {
    fill: "#333333",
    height: 9,
    id: "svg_17",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    width: 15,
    x: 291.5,
    y: 106.5
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: "normal",
    id: "svg_20",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 0,
    textAnchor: "middle",
    x: 315,
    xmlSpace: "preserve",
    y: 134
  }, "SD"), /*#__PURE__*/React.createElement("rect", {
    fill: "#333333",
    height: 9,
    id: "svg_21",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    width: 15,
    x: 291.5,
    y: 125.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#333333",
    height: 28,
    id: "svg_26",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    width: 31,
    x: 216.5,
    y: 258.5
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "normal",
    id: "svg_29",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 231.5,
    xmlSpace: "preserve",
    y: 277.5
  }, "\u25BC"), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 16,
    fontWeight: "bold",
    id: "svg_30",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 203,
    xmlSpace: "preserve",
    y: 221
  }, "TAKEMOTO"), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "normal",
    id: "svg_31",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 203,
    xmlSpace: "preserve",
    y: 237
  }, "TWPM"), /*#__PURE__*/React.createElement("text", {
    fill: "#ff7f00",
    fontFamily: "Roboto",
    fontSize: 39,
    fontWeight: "normal",
    id: "svg_32",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 243.82813,
    xmlSpace: "preserve",
    y: 194
  }, "0.000"), /*#__PURE__*/React.createElement("text", {
    fill: "#4c4c4c",
    fontFamily: "Roboto",
    fontSize: 39,
    fontWeight: "normal",
    id: "svg_33",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 150.82813,
    xmlSpace: "preserve",
    y: 194
  }, "000"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwpmDark);
export default __webpack_public_path__ + "static/media/twpm_dark.5fca8f8e.svg";
export { ForwardRef as ReactComponent };